<template>
  <div v-if="isShowLogin" class="login">
    <div class="slogan-title">
      <h1>让服务更美好，让连锁更简单</h1>
      <p>微海翘财，连锁企业的财务管家～</p>
    </div>
    <div class="content-box">
      <login-form />
      <div class="box-explain">
        <div class="explain-top">联系热线：13472858253</div>
      </div>
    </div>
    <div class="footer">
      ©{{ showYear }} 上海餐易通科技有限公司 ©版权所有
      <span @click="goHref">沪ICP备18046026号-2</span>
    </div>
  </div>
  <div v-else class="alt-loading" :style="`background-image: url(${loading})`"></div>
</template>
<script>
import LoginForm from './components/login_form_new'
import MenuIcon from '@/components/common-icon/MenuIcon'
import router from '@/router'
import { axios } from '@/utils/request'
import { login } from '@/utils/mixin'
const loading = require('@/assets/images/loading.gif')

export default {
  name: 'Login',
  mixins: [login],
  components: {
    LoginForm,
    MenuIcon
  },
  computed: {
    showYear () {
      return new Date().getFullYear()
    }
  },
  data () {
    return {
      loginIcon: {
        height: '70px',
        width: '70px'
      },
      isShowLogin: false,
      params: {
        systemFlag: '',
        loginType: '',
        systemTerminalFlag: ''
      },
      token: '',
      loading
    }
  },
  created () {
    let { token, systemFlag, loginType, systemTerminalFlag } = this.$route.query
    if (this.$store.getters.roles.length) {
      return window.location.reload()
    }
    if (token) {
      this.isShowLogin = false
      this.token = token
      loginType = loginType ? Number(loginType) : 16
      this.params = { systemFlag, loginType, systemTerminalFlag }
      this.auLogin()
    } else {
      this.isShowLogin = true
    }
  },
  methods: {
    goHref () {
      const url = 'https://beian.miit.gov.cn/#/Integrated/index'
      window.open(url, '_blank')
    },
    goSuperLogin () {
      router.push({ name: 'SuperLogin' })
    },
    auLogin() {
      const bases = {
        development: '/dev',
        test: '/tes',
        preview: '/pre',
        production: '/pro'
      }
      const env = process.env.NODE_ENV
      const baseURL = bases[env] ? bases[env] : '/pro'
      if (this.token) {
        this.$cookie.set('systemName', 'UCS')
        this.$cookie.set('sso_sys_token', this.token)
        axios({ baseURL: baseURL, url: '/api/uac/web/portal/uac/loginIn', method: 'post', data: { ...this.params } })
          .then(({ code, data }) => {
            if (code === '0') {
              this.Login(data).then((user) => this.successLogin(user))
            } else {
              this.isShowLogin = true
            }
          }).catch(() => {
            this.isShowLogin = true
          })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "~ant-design-vue/lib/style/index";
.alt-loading {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80px;
  background-color: #fff;
}
.login {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  min-width: 1280px;
  overflow: auto;
  background: url(./images/login_bg.jpg) no-repeat left center;
  background-size: cover;
  @media screen and (max-height: 1000px) {
    min-height: 880px;
    .slogan-title {
      top: 100px;
      left: 100px;
    }
    .content-box {
      top: 100px;
      right: 100px;
    }
  }
  @media screen and (max-height: 720px) {
    min-height: 800px;
    .slogan-title {
      top: 50px;
      left: 50px;
    }
    .content-box {
      top: 50px;
      right: 50px;
    }
  }
}
h1 {
  color: @primary-color;
  font-size: 28px;
}
.slogan-title {
  position: absolute;
  top: 100px;
  left: 100px;
  display: flex;
  flex-direction: column;
  height: 200px;
  h1 {
    font-size: 38px;
    color: rgba(0, 0, 0, 0.85);
    font-family: "经典雅黑";
    margin-bottom: 19px;
  }
  p {
    font-size: 23px;
    color: rgba(134,134,134,0.85);
  }
}
.footer {
  position: absolute;
  bottom: 38px;
  left: 50%;
  transform: translateX(-50%);
  height: 12px;
  font-size: 12px;
  color: rgba(51,51,51,0.60);
  letter-spacing: 0;
  line-height: 12px;
  span {
    cursor: pointer;
  }
  .super-login {
    width: 14px;
    height: 14px;
    margin-left: 10px;
    cursor: pointer;
  }
}
.content-box {
  position: absolute;
  top: 180px;
  right: 200px;
  width: 480px;
  height: 600px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0px 2px 30px 0px rgba(0, 164, 151, 0.1);
  border-radius: 12px;
  .box-explain {
    position: absolute;
    bottom: -12px;
    left: 0;
    width: 100%;
    height: 64px;
    margin-top: 94px;
    .explain-top {
      color: rgba(0, 0, 0, .45);
      font-size: 14px;
      font-family: PingFangSC-Regular;
      line-height: 32px;
      text-align: center;
    }
  }
  .box-title {
    margin-top: 8px;
    margin-bottom: 40px;
    color: #666;
    font-size: 22px;
    font-family: Alibaba-PuHuiTi-L;
    letter-spacing: 4px;
    text-align: center;
  }
  .box-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 76px 0  80px 0;
    .anticon {
      color: #00a497;
    }
    .qiaocai {
      color: #00a497;
    }
    .icon-font {
      margin-left: 8px;
      color: #000;
      font-weight: 600;
      font-size: 32px;
    }
  }
}
.pic {
  flex: 1;
  background-image: url('./images/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0 10px 14px 0 rgba(77, 83, 98, .06);
}
.form-area {
  width: 480px;
  height: 100%;
  background: #fff;
  box-shadow: 0 10px 14px 0 rgba(77, 83, 98, .06);
}
.title {
  display: flex;
  align-items: baseline;
  & > h1 {
    margin-right: 8px;
  }
}
</style>
